import { getWorkFlowToken, setWorkFlowToken, removeWorkFlowToke } from '@/utils/auth'
import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'

const getDefaultState = () => {
  return {
    token: getWorkFlowToken(),
    userInfo: {},
    roles: [],
    permission: { permissionButtons: [], permissionMenus: [] }
  }
}
var user = {
  state: getDefaultState(),
  mutations: {
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    setPermissionButtons: (state, permissionButtons) => {
      state.permission.permissionButtons = permissionButtons
    },
    setPermissionMenus: (state, permissionMenus) => {
      state.permission.permissionMenus = permissionMenus
    }
  },
  actions: {
    /**
     * 登录
     */
    login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'user/userLogin', userInfo).then(response => {
          commit('SET_TOKEN', response)
          setWorkFlowToken(response)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取用户详情
    */
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'user/getInfo').then(response => {
          if (response.roles && response.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', response.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_USER_INFO', response.admin)
          commit('setPermissionButtons', response.admin.perms)
          commit('setPermissionMenus', response.admin.menuPerms)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

  }
}
export default user
